import { useEffect, useState } from "react";
import { api } from "./api";

const SITE = "NasDeal";
const DEFAULT_DESC = "NasDeal, parfumerie en ligne : parfums homme, femme, mixtes, parfums de Dubaï, brumes et muscs. Le luxe à portée de tous.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, image, jsonLd }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} — Le luxe à portée de tous`;
    const desc = description || DEFAULT_DESC;
    document.title = full;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:image", image || `${window.location.origin}/logo-nasdeal.jpg`);
    setMeta("name", "twitter:card", "summary_large_image");
    let s = document.getElementById("page-jsonld");
    if (ld) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "page-jsonld";
        document.head.appendChild(s);
      }
      s.textContent = ld;
    } else if (s) s.remove();
  }, [title, description, image, ld]);
}

let catCache = null;
export function useCategories() {
  const [cats, setCats] = useState(catCache || []);
  useEffect(() => {
    if (catCache) return;
    api.get("/categories").then((r) => {
      catCache = r.data;
      setCats(r.data);
    }).catch(() => {});
  }, []);
  return cats;
}
